export default __webpack_public_path__ + "static/media/leg-icon-shopping.64befd08.png";